module.exports = __webpack_public_path__ + "img/icon_video_interativo_e_personalizado.1276863d.svg";